import { ComponentPropsWithRef } from 'react';
import { Controller } from 'react-hook-form';

import { InputSwitch } from '../input/input-switch';

type InputSwitchControllerProps = Omit<
  ComponentPropsWithRef<typeof InputSwitch>,
  'name' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: boolean;
  onChange?: (value: boolean) => void;
  onBlur?: () => void;
};

export function InputSwitchController(props: InputSwitchControllerProps) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputSwitch
          {...defaultProps}
          onChange={e => {
            onControllerChange(e);
            onControllerBlur();

            onChange?.(e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue ?? ''}
    />
  );
}
